import { render, staticRenderFns } from "./CustomFieldConfigurationForm.vue?vue&type=template&id=5032c957&scoped=true&"
import script from "./CustomFieldConfigurationForm.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldConfigurationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFieldConfigurationForm.vue?vue&type=style&index=0&id=5032c957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032c957",
  null
  
)

export default component.exports